'use strict';

var truncate = require("./lib/truncate");
var getLength = require("utf8-byte-length/browser");
module.exports = truncate.bind(null, getLength);



//////////////////
// WEBPACK FOOTER
// ./node_modules/truncate-utf8-bytes/browser.js
// module id = 205
// module chunks = 0